import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ModuleTokens } from './users-base.constant';
import { reducer } from './users-base.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      ModuleTokens.Name,
      reducer
    )
  ]
})
export class UsersBaseModule {

}
